import React from 'react';
import './TermsAndConditions.css';
import { Link } from 'react-router-dom';

const sections = [
    {
        id: 'information-collection',
        title: '1. Information Collection',
        content: [
            {
                subtitle: '1.1 Personal Information',
                text: 'We may collect personal identification information from you in various ways — when you visit our website, place an order, fill out a form, subscribe to our newsletter, or interact with other activities or services we make available. This may include your name, email address, mailing address, phone number, and payment information. You may choose not to provide this information, though it may limit access to certain features.',
            },
            {
                subtitle: '1.2 Non-Personal Information',
                text: 'We may collect non-personal identification information such as browser name, device type, operating system, and internet service provider details whenever you interact with our website.',
            },
            {
                subtitle: '1.3 Cookies & Tracking',
                text: 'We use cookies, pixels, and similar technologies to power and improve our site, remember your preferences, and run analytics. Most browsers accept cookies by default; you can choose to disable them via browser settings, though this may affect site functionality.',
            },
        ],
    },
    {
        id: 'information-usage',
        title: '2. How We Use Your Information',
        content: [
            {
                subtitle: '2.1 Order Processing',
                text: 'We use your information to process and fulfill orders, handle payments, arrange shipping, manage returns and exchanges, and send order-related notifications.',
            },
            {
                subtitle: '2.2 Marketing & Communication',
                text: 'With your consent, we may send promotional emails or SMS communications about products and services. You may opt out at any time using the unsubscribe link in any email. Non-promotional messages (e.g., order updates) will continue regardless.',
            },
            {
                subtitle: '2.3 Security & Fraud Prevention',
                text: 'We use your information to detect and investigate fraudulent, illegal, or malicious activity. Keep your account credentials safe and contact us immediately if you suspect unauthorized access.',
            },
            {
                subtitle: '2.4 Service Improvement',
                text: 'Aggregated, non-identifiable data may be used to analyze user behavior and improve our website experience. We do not sell, trade, or rent your personal information to third parties.',
            },
        ],
    },
    {
        id: 'information-disclosure',
        title: '3. Disclosure of Information',
        content: [
            {
                subtitle: '3.1 Service Providers',
                text: 'We may share your information with trusted third-party vendors who assist in operating our website — including payment processors, shipping partners, IT management, data analytics, and customer support providers.',
            },
            {
                subtitle: '3.2 Business & Marketing Partners',
                text: 'We work with partners such as Shopify to provide and advertise our services. These partners operate under their own privacy policies.',
            },
            {
                subtitle: '3.3 Legal Obligations',
                text: 'We may disclose your information to comply with applicable laws, respond to legal requests (subpoenas, court orders), enforce our terms of service, or protect the rights and safety of our users and the public.',
            },
            {
                subtitle: '3.4 Business Transfers',
                text: 'In the event of a merger, acquisition, or bankruptcy, your information may be transferred as part of the transaction, subject to the same privacy protections.',
            },
        ],
    },
    {
        id: 'your-rights',
        title: '4. Your Rights & Choices',
        content: [
            {
                subtitle: '4.1 Access & Portability',
                text: 'You may request access to the personal information we hold about you, including details of how it is used and shared. You may also request a copy to transfer to a third party.',
            },
            {
                subtitle: '4.2 Correction & Deletion',
                text: 'You have the right to request correction of inaccurate data or deletion of your personal information, subject to legal retention obligations.',
            },
            {
                subtitle: '4.3 Withdraw Consent',
                text: 'Where processing is based on your consent, you may withdraw it at any time. You may also request restriction of processing or appeal any decision we make regarding your data.',
            },
        ],
    },
    {
        id: 'data-security',
        title: '5. Data Security & Retention',
        content: [
            {
                subtitle: '5.1 Security Measures',
                text: 'We implement appropriate technical and organizational measures to protect your information from unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the internet is 100% secure.',
            },
            {
                subtitle: '5.2 Retention Period',
                text: 'We retain your personal information as long as necessary to maintain your account, provide services, comply with legal obligations, resolve disputes, and enforce agreements.',
            },
        ],
    },
    {
        id: 'international',
        title: '6. International Users',
        content: [
            {
                subtitle: '6.1 Cross-Border Transfers',
                text: "Your information may be transferred to, stored, and processed in countries outside your own, including India and the United States. Where required, we rely on recognized transfer mechanisms such as the European Commission's Standard Contractual Clauses.",
            },
        ],
    },
    {
        id: 'children',
        title: "7. Children's Privacy",
        content: [
            {
                subtitle: '7.1 Age Restriction',
                text: 'Our services are not intended for individuals under 16 years of age. We do not knowingly collect personal information from children. If you believe a child has submitted information to us, please contact us and we will delete it promptly.',
            },
        ],
    },
    {
        id: 'user-content',
        title: '8. User Generated Content',
        content: [
            {
                subtitle: '8.1 Public Content',
                text: 'Product reviews or other content you submit publicly on our site will be accessible by anyone. We are not responsible for how others use information you choose to make public.',
            },
        ],
    },
    {
        id: 'changes',
        title: '9. Changes to This Policy',
        content: [
            {
                subtitle: '9.1 Policy Updates',
                text: 'We may update these Terms & Conditions and Privacy Policy from time to time. We will post the revised version on our site with an updated date. Continued use of the website after any changes constitutes your acceptance of the revised policy.',
            },
        ],
    },
    {
        id: 'contact',
        title: '10. Contact Us',
        content: [
            {
                subtitle: '10.1 Get in Touch',
                text: 'For any questions about this policy or to exercise your rights, contact us at:\n\nEmail: sales@partsklik.com\nPhone: +91 7011969546\nAddress: A-15, GT Karnal Road Industrial Area, Ashok Vihar, New Delhi, Delhi, 110033 , India',
            },
        ],
    },
];

const TermsAndConditions = () => {
    return (
        <div className="tnc-page">

            {/* ── HEADER ── */}
            <div className="tnc-header">
                <div className="tnc-header-inner">
                    <Link to="/" className="tnc-back-btn">
                        <i className="fa-solid fa-arrow-left"></i> Back to Home
                    </Link>
                    <span className="tnc-label">Legal Document</span>
                    <h1 className="tnc-title">Terms &amp; Conditions</h1>
                    <p className="tnc-subtitle">
                        Governing the use of Partsklik LLP's services — including German Purje &amp; Turbowale platforms.
                    </p>
                    <div className="tnc-meta">
                        <span><i className="fa-regular fa-calendar"></i> Last Updated: April 3, 2024</span>
                        <span className="dot">•</span>
                        <span><i className="fa-solid fa-location-dot"></i> Partsklik LLP, Delhi, India</span>
                    </div>
                </div>
            </div>

            {/* ── CONTENT ── */}
            <div className="tnc-body">

                {/* Notice banner */}
                <div className="tnc-notice">
                    <i className="fa-solid fa-circle-info tnc-notice-icon"></i>
                    <p>
                        By accessing  <strong>turbowale.com</strong>, or <strong>germanpurje.com</strong> you agree to the terms described below.
                    </p>
                </div>

                {/* All sections rendered directly */}
                <div className="tnc-sections">
                    {sections.map((sec) => (
                        <div key={sec.id} id={sec.id} className="tnc-section">

                            <h2 className="tnc-section-title">{sec.title}</h2>
                            <div className="tnc-section-divider" />

                            {sec.content.map((item, idx) => (
                                <div key={idx} className="tnc-subsection">
                                    <h4 className="subsection-label">{item.subtitle}</h4>
                                    <p className="subsection-text">{item.text}</p>
                                </div>
                            ))}
                        </div>
                    ))}
                </div>

                {/* Footer */}
                <div className="tnc-footer">
                    <p>© {new Date().getFullYear()} Partsklik LLP. All rights reserved.</p>
                    <div className="tnc-footer-links">
                        <a href="https://turbowale.com" target="_blank" rel="noopener noreferrer">Turbowale</a>
                        <span>·</span>
                        <a href="https://germanpurje.com" target="_blank" rel="noopener noreferrer">German Purje</a>
                        <span>·</span>
                        <a href="mailto:sales@partsklik.com">sales@partsklik.com</a>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default TermsAndConditions;